import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const reasonsApi = api
  .enhanceEndpoints({ addTagTypes: ["inventories", "inventoryItems"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createInventory: builder.mutation({
        query: ({ name, branchId }) => ({
          url: `branchs/${branchId}/inventories`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
          }),
        }),
        invalidatesTags: ["inventories"],
      }),
      inventories: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/inventories`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["inventories"],
      }),
      createInventoryItem: builder.mutation({
        query: ({ inventoryId, nro, name, branchId }) => ({
          url: `branchs/${branchId}/inventory-items`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            nro,
            inventoryId,
          }),
        }),
        invalidatesTags: ["inventoryItems"],
      }),
      updateInventoryItem: builder.mutation({
        query: ({ id, nro, name, branchId }) => ({
          url: `branchs/${branchId}/inventory-items/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            name,
            nro,
          }),
        }),
        invalidatesTags: ["inventoryItems"],
      }),
      deleteInventoryItem: builder.mutation({
        query: ({ id, branchId }) => ({
          url: `branchs/${branchId}/inventory-items/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["inventoryItems"],
      }),
      inventoryItems: builder.query({
        query: ({ branchId, inventoryId, page, pageSize }) => {
          const params = new URLSearchParams();
          if (inventoryId)
            params.append("inventory_id", inventoryId.toString());
          if (page) params.append("page", page.toString());
          if (pageSize) params.append("per_page", pageSize.toString());

          return {
            url: `branchs/${branchId}/inventory-items${params.toString() ? `?${params.toString()}` : ""}`,
            method: RequestMethod.GET,
          };
        },
        providesTags: ["inventoryItems"],
      }),
    }),
  });

export const {
  useInventoriesQuery,
  useCreateInventoryMutation,
  useInventoryItemsQuery,
  useCreateInventoryItemMutation,
  useDeleteInventoryItemMutation,
  useUpdateInventoryItemMutation,
} = reasonsApi;
